var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLoginIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8917 23.66C18.7484 24.7683 17.5 24.5933 16.2984 24.0683C15.0267 23.5317 13.86 23.5083 12.5184 24.0683C10.8384 24.7917 9.9517 24.5817 8.94836 23.66C3.25503 17.7917 4.09503 8.855 10.5584 8.52833C12.1334 8.61 13.23 9.39167 14.1517 9.46167C15.5284 9.18167 16.8467 8.37667 18.3167 8.48167C20.0784 8.62167 21.4084 9.32167 22.2834 10.5817C18.6434 12.7633 19.5067 17.5583 22.8434 18.9C22.1784 20.65 21.315 22.3883 19.88 23.6717L19.8917 23.66ZM14.035 8.45833C13.86 5.85667 15.9717 3.71 18.3984 3.5C18.7367 6.51 15.6684 8.75 14.035 8.45833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLoginIcon);
export default __webpack_public_path__ + "static/media/appleLoginIcon.9d5ce03252c46fef31a4dd2f8caa6503.svg";
export { ForwardRef as ReactComponent };